export default {
  navTop: state => {
    const userNavTop = state.navTop.filter(link => link.auth !== false);
    const guestNavTop = state.navTop.filter(link => link.auth !== true);
    return state.token ? userNavTop : guestNavTop;
  },
  navMain: state => {
    const userNavMain = state.navMain.filter(link => link.auth !== false);
    const guestNavMain = state.navMain.filter(link => link.auth !== true);
    return state.token ? userNavMain : guestNavMain;
  },
  getReportData: state => {
    return state.report
  },
  getRegistrationData: state => {
    return state.register
  },
  getVoivodeships: state => {
    return state.voivodeships
  },
  getSecuredRequestHeader: state => {
    return {
      "Content-Type": "application/json",
      Authorization: `Bearer ${state.token}`
    }
  },
  isAuthenticated: state => !!state.token,
  authStatus: state => state.status,
  getLoginData: state => state.login,
  getToken: state => state.token,
  getUserData: state => state.user,
  getReportList: state => state.reportList,
  getReportTable: state => state.reportTable,
}